export default __webpack_public_path__ + "pgnv-assets/6b6e18afe6e6e6d909c0679d1c89bfbd.png";